// extracted by mini-css-extract-plugin
module.exports = {"box_image":"styles_box_image__3gFVc"};